import React, { Component } from 'react';
import packageJson from '../../../package.json';
import { constants, businessWebsiteUrl } from '../../constants/configuration';
import routes from '../../routes';
import asyncRoute from '../../helpers/hoc/asyncRoute';
import './AboutFudr.scss';

const Header = asyncRoute(() => import('../../components/Header'));
const Footer = asyncRoute(() => import('../../components/Footer'));

const aboutFudrConfig = constants.aboutFudr;

class AboutFudr extends Component {
  componentDidMount() {
    // Scroll to top to prevent browser scroll position persistence from other screens
    window.scrollTo({ top: 0 });
  }

  onBackClick = () => {
    this.props.history.goBack();
  };

  onTermsAndConditionsClick = () => {
    this.props.history.push(`${routes.containers.termsAndConditions}`);
  };

  onPrivacyClick = () => {
    this.props.history.push(`${routes.containers.privacyPolicy}`);
  };

  render() {
    return (
      <>
        <Header onBackClick={this.onBackClick} identifier={routes.containers.aboutFudr} />
        <div className="about-fudr" id="about-fudr-wrapper">
          <div className="about-fudr_title">{aboutFudrConfig.title}</div>
          <div className="about-fudr_description">
            <p>
              December Technologies Pvt. Ltd. aims to use the power of computing to empower eatery
              owners in all round business activities, to help them focus more on the quality of
              food and hospitality. While enabling customers with any form of communication with the
              restaurants on their fingertips.
            </p>
            <p>
              Introducing Fudr, a web app that provides you with a seamless outing experience where
              ever you go. All you need are a few taps on your smartphone. Be it the eatery down the
              lane or your favorite coffee bar just scan the QR code on your table and the
              application takes you directly to the menu. Select and confirm your order and pay from
              the comfort of your chair through your cell phone. Worried who gets that cheque? Have
              our split feature assist you to just pay your bill without the need to download
              anything.
            </p>
            <p>
              To know more about Fudr, log on to
              <a href={businessWebsiteUrl} target="_blank" rel="noopener">
                {` ${aboutFudrConfig.businessWebsiteText}`}
              </a>
            </p>
          </div>
          {/* commeting this section ad we aren't showing contact us section */}
          {/* <span className="about-fudr_line-break" />
          <div className="about-fudr_title">{aboutFudrConfig.contactUs}</div>
          <div className="about-fudr_description">
            <p>Please contact us for any questions or comments regarding this Platform.</p>
            <p>Phone: +91 9352665488</p>
            <p>
              Email: <a href="mailto:admin@fudr.in">admin@fudr.in</a>
            </p>
            <p>Time: Mon - Sat (9:00 - 18:00)</p>
            <p>December Technologies Private Limited</p>
            <p>
              Reg Office: Ground Floor, Gopal Tower , 32 , Gopalbari , Jaipur , Rajasthan 302001.
            </p>
          </div> */}
          <span className="about-fudr_line-break" />
          <div className="about-fudr_links" onClick={this.onTermsAndConditionsClick}>
            <div className="about-fudr_link">{aboutFudrConfig.termsAndConditions}</div>
            <i className="chevron right icon"></i>
          </div>
          <span className="about-fudr_line-break" />
          <div className="about-fudr_links" onClick={this.onPrivacyClick}>
            <div className="about-fudr_link">{aboutFudrConfig.privacyPolicy}</div>
            <i className="chevron right icon"></i>
          </div>
          <span className="about-fudr_line-break" />
          <Footer />
          <div className="about-outlet_app-version">{`v ${packageJson.version}`}</div>
        </div>
      </>
    );
  }
}

export default AboutFudr;
